import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import { ProductFragment } from '../products';
import EmptyPagePlaceholder from '../../common/components/EmptyPagePlaceholder';
import TrumpeterButterflyImage from '../../assets/images/trumpeter_butterfly.png';
import { RoutePaths } from '../../routes/AppRoutes';
import ProductListItem from './ProductListItem';

export interface ProductListProps {
  products: ProductFragment[];
}

export default function ProductList({ products }: ProductListProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'products']);

  return (
    products.length
      ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 3 }}>
          {products.map((product) => (
            <ProductListItem key={product.id} product={product} />
          ))}

        </Box>
      ) : (
        <EmptyPagePlaceholder
          title={t('products:no_product')}
          description={t('products:no_product_description')}
          imageSrc={TrumpeterButterflyImage}
          buttonLabel={t('products:add_a_product')}
          linkDestination={generatePath(RoutePaths.PRODUCT_ADD_INFO)}
          sx={{ pt: 0 }}
          buttonProps={{
            startIcon: <AddIcon />,
          }}
        />
      )
  );
}
